<script setup>
  import DropdownWidget from "./dropdown-widget.vue";

  defineProps({
    label: { type: Object, required: true },
    enableArchiving: { type: Boolean, default: true },
  });

  const emit = defineEmits(["copy", "archive", "delete"]);
</script>

<template>
  <DropdownWidget>
    <template #trigger>
      <button class="button is-outlined is-info is-small">
        <span>Actions</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down"></i>
        </span>
      </button>
    </template>

    <template #content>
      <div>
        <a class="dropdown-item" @click.prevent="emit('copy', label)">
          <span class="icon-text">
            <span class="icon">
              <i class="fa fa-copy"></i>
            </span>
            <span>Copy</span>
          </span>
        </a>

        <hr v-if="enableArchiving" class="dropdown-divider" />
      </div>

      <template v-if="enableArchiving">
        <a v-if="!label.archived" class="dropdown-item" @click.prevent="emit('archive', label)">
          <span class="icon-text">
            <span class="icon">
              <i class="far fa-eye-slash"></i>
            </span>
            <span>Archive</span>
          </span>
        </a>

        <a v-if="label.archived" class="dropdown-item" @click.prevent="emit('archive', label)">
          <span class="icon-text">
            <span class="icon has-text-success">
              <i class="far fa-trash-undo"></i>
            </span>
            <span>Restore</span>
          </span>
        </a>

        <a class="dropdown-item" @click.prevent="emit('delete', label)">
          <span class="icon-text">
            <span class="icon has-text-danger">
              <i class="fa fa-trash-alt"></i>
            </span>
            <span>Delete</span>
          </span>
        </a>
      </template>
    </template>
  </DropdownWidget>
</template>
